import * as React from 'react';

import { translate } from '~l10n/client';

import Input from '../../../../shared/components/elements/Input';

const names = [
  'Pond, Amy',
  'Tyler, Rose',
  'Williams, Rory',
  'Noble, Donna',
  'Mott, Wilfred',
  'Harkness, Jack',
  'Smith, Mickey',
  'Oswald, Clara',
];

interface StudentNameViewProps {
  controller: {
    nameChanged: (value: string) => void;
    doneClicked: () => void;
  };
  model: {
    error: boolean;
    name: string;
  };
}

const StudentNameView = ({ controller, model }: StudentNameViewProps) => {
  const { nameChanged, doneClicked } = controller;
  const { error, name } = model;

  return (
    <div className="take-quiz-container">
      <div id="enter-name-container" className="form vertical-align">
        {
          ' ' // This whitespace is required to preserve the layout between this element and its parent.
        }
        <div className="enter-name vertical-align-middle">
          <label htmlFor="student-name-input" style={{ fontSize: '18px' }}>
            {translate('Enter your name')}
          </label>
          <Input
            id="student-name-input"
            autoCorrect="off"
            autoFocus={true}
            maxLength={32}
            placeholder={names[Math.floor(Math.random() * names.length)]}
            status={{ error: error }}
            value={name}
            onChange={(event) => nameChanged(event.target.value)}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                doneClicked();
              }
            }}
          />
          <button
            id="submit-name-button"
            className="button button-primary button-large"
            onClick={doneClicked}
          >
            {translate('Done')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentNameView;
